export default __webpack_public_path__ + "static/media/releases.808d9207.svg";